import { render, staticRenderFns } from "./showAssiant.vue?vue&type=template&id=49c7af93&scoped=true"
import script from "./showAssiant.vue?vue&type=script&lang=js"
export * from "./showAssiant.vue?vue&type=script&lang=js"
import style0 from "./showAssiant.vue?vue&type=style&index=0&id=49c7af93&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c7af93",
  null
  
)

export default component.exports